import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '@/environments/environment';
import { ResponseSuccess } from '@core/models/response-success.model';

@Injectable({
    providedIn: 'root'
})
export class ApiService {

    constructor(protected http: HttpClient) {
    }

    /** @throws ResponseError */
    protected get(path: string, params: any = {}): Observable<ResponseSuccess> {
        return (this.http.get as any)(`${environment.apiUrl}${path}`, {params: ApiService.formatParams(params)})
            .pipe(catchError(ApiService.formatErrors));
    }

    /** @throws ResponseError */
    protected getFile(path: string, params: any = {}): Observable<any> {
        return (this.http.get as any)(`${environment.apiUrl}${path}`, {
            params: ApiService.formatParams(params),
            responseType: 'blob'
        })
        .pipe(catchError(ApiService.formatErrors));
    }

    /** @throws ResponseError */
    protected put(path: string, body: any = {}): Observable<ResponseSuccess> {
        if (body instanceof FormData) {
            body.append('_method', 'PUT');
            return (this.http.post as any)(`${environment.apiUrl}${path}`, body)
                .pipe(catchError(ApiService.formatErrors));
        }

        return (this.http.put as any)(`${environment.apiUrl}${path}`, this.formatBody(body))
            .pipe(catchError(ApiService.formatErrors));
    }

    /** @throws ResponseError */
    protected patch(path: string, body: any = {}): Observable<ResponseSuccess> {
        if (body instanceof FormData) {
            body.append('_method', 'PATCH');
            return (this.http.post as any)(`${environment.apiUrl}${path}`, body)
                .pipe(catchError(ApiService.formatErrors));
        }

        return (this.http.patch as any)(`${environment.apiUrl}${path}`, this.formatBody(body))
            .pipe(catchError(ApiService.formatErrors));
    }

    /** @throws ResponseError */
    protected post(path: string, body: any = {}, options: any = {}): Observable<ResponseSuccess> {
        return (this.http.post as any)(`${environment.apiUrl}${path}`, this.formatBody(body), options)
            .pipe(catchError(ApiService.formatErrors)) as unknown as Observable<ResponseSuccess>;
    }

    /** @throws ResponseError */
    protected delete(path: any): Observable<ResponseSuccess> {
        return (this.http.delete as any)(`${environment.apiUrl}${path}`)
            .pipe(catchError(ApiService.formatErrors));
    }

    /** @throws ResponseError */
    protected deleteBis(path: string, params: any = {}): Observable<ResponseSuccess> {
        return (this.http.delete as any)(`${environment.apiUrl}${path}`, {params: ApiService.formatParams(params)})
            .pipe(catchError(ApiService.formatErrors));
    }

    private formatBody(body: any): any {
        if (body instanceof FormData) {
            return body;
        }

        for (let key of Object.keys(body)) {
            if (body[key] instanceof Date) {
                // if (body[key].isValid()) {
                //   body[key] = body[key].format('YYYY-MM-DD HH:mm');
                // }
            } else if (body[key] instanceof Object) {
                body[key] = this.formatBody(body[key]);
            }
        }
        return body;
    }

    private static formatErrors(error: any) {
        return throwError(error.error);
    }

    public static formatParams(params: any): any {
        let httpParams = new HttpParams();

        if (!params) return httpParams;

        for (let key of Object.keys(params)) {
            const value = params[key];

            if (value === null || value === undefined) continue;
            if (typeof value === 'string' && value?.length === 0) continue;

            if (Array.isArray(params[key])) {
                value.forEach((v: any) => {
                    httpParams = httpParams.append(`${key}[]`, `${v}`);
                });
            } else if (params[key] instanceof Date) {
                httpParams = httpParams.append(key, value.toISOString());
            } else if (typeof params[key] === 'boolean') {
                httpParams = httpParams.append(key, params[key] ? '1' : '0');
            } else if (typeof params[key] === 'object') {
                for (let objKey in value) {
                    if (value[objKey] === null || value[objKey] === undefined) continue;
                    if (typeof value[objKey] === 'string' && value[objKey]?.length === 0) continue;

                    httpParams = httpParams.append(`${key}[${objKey}]`, `${value[objKey]}`);
                }
            } else {
                httpParams = httpParams.append(key, `${params[key]}`);
            }
        }

        return httpParams;
    }
}
